"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudiencePickerView = void 0;
var _react = require("react");
var _AudiencePicker = require("../../AudiencePicker");
var _EnvironmentManager = require("../EnvironmentManager.provider");
var _EnvironmentManager2 = _interopRequireDefault(require("../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AudiencePickerView = props => {
  const {
    view
  } = props;
  const styles = (0, _EnvironmentManager2.default)();
  const {
    audiencePickerProvider,
    environmentData,
    getLabel
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const isSelectedTeachers = environmentData.Teachers.length > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: styles['cc-EnvironmentManager_AudiencePicker'],
    "data-testid": `audiencePickerView-${view}`,
    children: isSelectedTeachers ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AudiencePicker.AudiencePicker, {
      ...audiencePickerProvider,
      view: view
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        border: '1px solid rgb(224, 224, 224)',
        borderRadius: '.7rem',
        height: '100%',
        overflow: 'hidden',
        padding: '1rem',
        color: '#75758b'
      },
      children: getLabel('participants_should_select_operator_teachers')
    })
  });
};
exports.AudiencePickerView = AudiencePickerView;